import { render } from "./PortfolioProjectDetailsCard.vue?vue&type=template&id=58b099a8"
import script from "./PortfolioProjectDetailsCard.vue?vue&type=script&lang=js"
export * from "./PortfolioProjectDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amane/Documents/A++/AMANE/amane_dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__